// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__31PHv","context":"Main_context__3ZQhc","tip":"Main_tip__A19SF","exit":"Main_exit__38ASr"};